import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AlcmeonContextService } from '../alcmeon-context/alcmeon-context.service';
import { AbstractAlcmeonBackendInterceptor } from './abstract-alcmeon-backend-interceptor';

/**
 * Interceptor that sets the 'Athorization' header if we have a JWT.
 */
@Injectable()
export class JWTHeaderInterceptor extends AbstractAlcmeonBackendInterceptor {
  constructor(private jwtService: AlcmeonContextService) {
    super();
  }

  protected doIntercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const config: any = {};
    if (this.jwtService.hasJwt()) {
      config.headers = request.headers.set('Authorization', 'Bearer ' + this.jwtService.jwt);
    }
    return next.handle(request.clone(config));
  }
}
